import React from "react";
import {
  createUpdateIndustryType,
  getIndustryTypes,
} from "../../helpers/backend_helper";
import MasterList from "./MasterList";

const IndustryType = ({ createRequest = 0, tourRequest = 0 }) => (
  <MasterList
    createRequest={createRequest}
    tourRequest={tourRequest}
    label="Industry Type"
    pluralLabel="Industry Types"
    listMasters={() => getIndustryTypes(true)}
    createMaster={createUpdateIndustryType}
    fileName="industry-types"
  />
);

export default IndustryType;
